<div class="flex flex-col justify-center items-center text-center place-content-center place-items-center h-full">
  <i class="fa-duotone fa-solid fa-face-sad-sweat text-[250px] mb-9"></i>
  <h1 i18n>Sorry, page not found!</h1>
  <p i18n class="text-base">
    The link may be broken, or the page has been removed.<br />
    <!-- TODO: Add link to re-login to Pulse -->
    Please click here to re-login to Pulse or <a class="underline" [href]="supportEmailHref">create</a> a support ticket.<br /><br />
  </p>
</div>
